// GENERATED from registry/aliases.yaml by scripts/gen_aliases_js.py. Do not edit.
//
// `python3 scripts/gen_aliases_js.py --check` fails CI if this file and the YAML disagree, so an
// edit here is an edit that will be reverted. Change the YAML.

/** What people type -> the word to search alongside it. Keys and values lower-cased. */
export const ALIASES = {
  "hubble": "hst",
  "jwst": "james webb",
  "golden record": "voyager",
  "space station": "iss",
  "station": "iss",
  "international space station": "iss",
  "tiangong": "css",
  "chandra": "cxo",
  "galactic center": "sagittarius a",
  "galactic centre": "sagittarius a",
  "cone nebula": "christmas tree cluster",
  "lobster nebula": "war and peace",
  "pillars of creation": "eagle nebula",
  "seven sisters": "pleiades",
  "chinese space station": "css"
};
